import React from 'react';
import { Formik } from 'formik';
import '../AuthPages.scss';
import { useForgotPasswordVM } from './useForgotPasswordVM';
import logo from 'assets/images/logo-colored.svg';
import { Button } from 'components/Button/Button';

interface ForgotPasswordFormValues {
    email: string;
}

export const ForgotPassword: React.FC = () => {
    const { handleForgotPassword, forgotPasswordErrorMessage, forgotPasswordMode, handleBackToLogin } = useForgotPasswordVM();

    return (
        <div id="forgot-password">
            <div className="forgot-password-wrapper">
                <img src={logo} className="logo" />
                <div className="forgot-password-form">
                    {forgotPasswordMode === 'form' ? (
                        <Formik<ForgotPasswordFormValues>
                            initialValues={{
                                email: ''
                            }}
                            onSubmit={async (
                                values: ForgotPasswordFormValues,
                                { setSubmitting }: { setSubmitting: (isSubmitting: boolean) => void }
                            ) => {
                                const { email } = values;
                                await handleForgotPassword(email);
                                setSubmitting(false);
                            }}
                        >
                            {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
                                <form onSubmit={handleSubmit} className="form">
                                    <h1>Réinitialisez votre mot de passe</h1>
                                    <input
                                        type="email"
                                        name="email"
                                        placeholder="Adresse e-mail"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.email}
                                        required
                                    />
                                    {errors.email && touched.email && errors.email}
                                    {forgotPasswordErrorMessage && <p className="api-error">Adresse e-mail non trouvée</p>}
                                    <Button label="Réinitialiser mon mot de passe" variant="dark" type="submit" disabled={isSubmitting} />
                                    <span onClick={handleBackToLogin}>Retour à la page de connexion</span>
                                </form>
                            )}
                        </Formik>
                    ) : (
                        <div className="forgot-password-success">
                            <h1>Demande envoyée</h1>
                            <p>Un e-mail vous a été envoyé avec les instructions pour réinitialiser votre mot de passe.</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
